import { render } from "./Equipment.vue?vue&type=template&id=53060b4e"
import script from "./Equipment.vue?vue&type=script&lang=ts"
export * from "./Equipment.vue?vue&type=script&lang=ts"
script.render = render

export default script